module.exports = __webpack_public_path__ + "img/kong.6b8b4938.png";